const axios = require('axios')

const getDomainOrigin = () => {
  const domains = []
  domains['reescrever.app'] = 'https://api-prod-client.reescrever.app'
  domains['dev.reescrever.app'] = 'https://api-dev-client.reescrever.app'
  domains['staging.reescrever.app'] = 'https://api-staging-client.reescrever.app'
  domains.localhost = 'http://localhost:8080/dev'

  const domainOrigin = window.location.hostname

  return domains[domainOrigin.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i)[1]] || 'https://api-prod-client.reescrever.app'
}


/**
 * @param {string} text - Create short sentence (summary) from sentence
 */
const summarizedSentence = async ({
  text
}) => axios.post('https://q1f8kd88uc.execute-api.us-east-1.amazonaws.com/prod/summary', { text })
  .then((response) => response.data)
  .catch(async (err) => { console.log('ERRO', err) })

export {
  getDomainOrigin, summarizedSentence
}
